module.exports = __webpack_public_path__ + "img/4-5.775c43b7.svg";